import Vue from 'vue'
import news from './news.vue'
import '@/common/config.js'
import utils from '@/common/js/utils.js'
// 引入公共CSS文件
import '@/common/app.css';
import 'swiper/css/swiper.min.css';
import {Icon} from "element-ui";

Vue.prototype.$util = utils;
Vue.use(Icon);

new Vue({
    render: h => h(news),
}).$mount('#app')